// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__3ujK7","expanded":"Sidebar_expanded__3kkPi","inner":"Sidebar_inner__bqfAl"};